<template>
  <div class="botao-dropdown-container">
    <button
      :tabindex="desabilitado ? '-1' : '0'"
      ref="botaoDropdown"
      @keydown.prevent.up="dropdownAltera(-1)"
      @keydown.prevent.down="dropdownAltera(+1)"
      @keydown.prevent.enter="enter"
      @keydown.prevent.esc="esc"
      @click="abreBotao"
      @contextmenu.prevent="abreBotao"
      @blur="blurBotao"
      :class="['botao-dropdown', { 'botao-dropdown-desabilitado': desabilitado }]"
    >
      <LoadingPadraoContainerMini v-if="loading" delay="5000" />
      <font-awesome-icon v-else :icon="icone" />
    </button>
    <div
      ref="botaoDropdownLista"
      v-show="this.exibelistaBotao"
      :class="[
        'lista-botao-dropdown',
        { 'lista-botao-dropdown-notificacao': notificacao },
        { 'alinha-esquerda': direcao == 'esquerda' },
        { 'alinha-direita': direcao == 'direita' }
      ]"
    >
      <div v-if="opcoes && opcoes.length > 0">
        <div
          @mouseover="
            setHover(true);
            dropdownSeleciona(index);
          "
          @mouseleave="setHover(false)"
          class="lista-botao-dropdown-item-container"
          @click="dropdownClick"
          @contextmenu.prevent="dropdownClick"
          v-for="(item, index) in opcoes.slice(0, carregaElemento)"
          :key="index"
        >
          <div
            v-if="notificacao"
            :ref="comparaItem(item) ? 'selecionado' : ''"
            :class="[
              'lista-botao-dropdown-item-notificacao',
              { 'lista-botao-dropdown-item-selecionado': comparaItem(item) }
            ]"
          >
            <div>
              <div>
                {{ item.descricao }}
              </div>
              <div class="lista-botao-notificacao-data">
                <font-awesome-icon icon="calendar" />
                <div>{{ item.data_alteracao }}</div>
              </div>
            </div>
          </div>
          <div
            v-else
            :class="[
              'lista-botao-dropdown-item',
              { 'lista-botao-dropdown-item-selecionado': item == itemSelecionado }
            ]"
          >
            <div v-if="item.icone">
              <font-awesome-icon :icon="item.icone" />
            </div>
            <div>
              {{ item.nome }}
            </div>
          </div>
        </div>
      </div>
      <div v-else :class="['lista-botao-dropdown-item']">
        {{ semOpcoes ? semOpcoes : "Sem opções disponíveis" }}
      </div>
    </div>
    <div
      @click="clickNotificacao"
      @contextmenu.prevent="clickNotificacao"
      class="esfera-notificacao"
      v-if="notificacao && notificacao > 0 && !desabilitado && !loading"
    >
      {{ notificacao > 999 ? "+999" : notificacao }}
    </div>
  </div>
</template>

<script>
import LoadingPadraoContainerMini from "@/components/LoadingPadrao/LoadingPadraoContainerMini.vue";
export default {
  name: "BotaoDropdown",
  components: {
    LoadingPadraoContainerMini
  },
  props: {
    icone: String,
    opcoes: Array,
    semOpcoes: String,
    direcao: String,
    loading: Boolean,
    notificacao: String,
    desabilitado: Boolean
  },
  data() {
    return {
      exibelistaBotao: false,
      carregaElemento: 50,
      itemSelecionado: null,
      hover: false,
      index: null
    };
  },
  mounted() {
    if (this.$refs.botaoDropdownLista) {
      this.$refs.botaoDropdownLista.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    if (this.$refs.botaoDropdownLista) {
      this.$refs.botaoDropdownLista.addEventListener("scroll", this.handleScroll);
    }
  },
  computed: {
    exibeLista() {
      return this.exibelistaBotao && this.opcoes && !!this.opcoes.length;
    }
  },
  methods: {
    clickNotificacao() {
      this.abreBotao();
      this.$refs.botaoDropdown.focus();
    },
    comparaItem(item) {
      return JSON.stringify(item) == JSON.stringify(this.itemSelecionado);
    },
    esc() {
      this.$refs.botaoDropdown.blur();
    },
    enter() {
      if (this.exibelistaBotao) {
        this.dropdownClick();
      } else {
        this.abreBotao();
      }
    },
    abreBotao() {
      this.dropdownSeleciona(null);
      this.index = null;
      this.toggleBotao();
    },
    handleScroll(event) {
      if (
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 100 &&
        this.opcoes.length > this.carregaElemento
      ) {
        this.carregaElemento += 50;
      }
    },
    toggleBotao() {
      this.carregaElemento = 50;
      if (this.loading || this.desabilitado) return;
      // this.exibelistaBotao = !this.exibelistaBotao;
      if (!this.exibelistaBotao) {
        this.exibelistaBotao = true;
      } else {
        this.blurBotao();
      }
      this.$emit("clicou");
    },
    blurBotao() {
      if (this.hover) return;
      this.$emit("saiu");
      this.exibelistaBotao = false;
    },
    dropdownSeleciona(index) {
      this.index = index;
      this.itemSelecionado = this.opcoes[index];
    },
    dropdownAltera(alteracao) {
      if (this.index == null) {
        this.index = alteracao == 1 ? 0 : -1;
      } else {
        this.index += alteracao;
      }
      switch (this.index) {
        case -1:
          if (this.opcoes.length > this.carregaElemento) {
            this.index = 0;
          } else {
            this.index = this.opcoes.length - 1;
          }
          this.itemSelecionado = this.opcoes[this.index];
          break;
        case this.opcoes.length:
          this.index = 0;
          this.itemSelecionado = this.opcoes[this.index];
          break;
        default:
          this.itemSelecionado = this.opcoes[this.index];
          break;
      }
      this.$nextTick(() => {
        if (this.$refs.selecionado && this.$refs.selecionado[0]) {
          this.$refs.selecionado[0].scrollIntoView({
            behavior: "auto",
            block: "nearest",
            inline: "center"
          });
        }
      });
    },
    dropdownClick() {
      if (this.index != null && this.index >= 0) {
        this.$emit("dropdownClick", this.itemSelecionado);
      }
      this.index = null;
      this.$emit("saiu");
      this.hover = false;
      this.exibelistaBotao = false;
    },
    setHover(bool) {
      this.hover = bool;
    }
  }
};
</script>

<style lang="scss" scoped>
.botao-dropdown-container {
  position: relative;
  display: flex;
  justify-content: center;
}
.botao-dropdown {
  background: var(--azul5);
  font-size: 18px;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  &:hover,
  &:focus {
    background: var(--azul3);
  }
}
.botao-dropdown-desabilitado {
  color: var(--cinza2);
  cursor: default;
  &:hover,
  &:focus {
    background: var(--azul5);
  }
}
.lista-botao-dropdown {
  position: absolute;
  top: 35px;
  // width: 100px;
  background: var(--branco);
  color: var(--preto);
  z-index: 1000;
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: auto;
  border: 1px solid var(--cinza02);
}
.lista-botao-dropdown-item {
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
  white-space: nowrap;
  // &:hover {
  //   background: var(--cinza01);
  // }
  > div {
    padding-left: 5px;
    &:first-child {
      padding-left: 0;
    }
  }
}
.lista-botao-dropdown-item-selecionado {
  background: var(--cinza01);
}
.lista-botao-dropdown-item-container {
  border-bottom: 1px solid var(--cinza02);
  &:last-child {
    border-bottom: none;
  }
}
.alinha-esquerda {
  right: 0;
}
.alinha-direita {
  left: 0;
}
.esfera-notificacao {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 11px;
  // width: 9px;
  text-align: center;
  padding: 0 3px;
  border-radius: 2px;
  background: #cf2043e3;
  font-size: 9px;
  line-height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.lista-botao-dropdown-item-notificacao {
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: var(--cinza01);
  }
  > div {
    padding-left: 5px;
    &:first-child {
      padding-left: 0;
    }
  }
}
.lista-botao-notificacao-data {
  display: flex;
  align-items: center;
  > div {
    margin-left: 5px;
  }
}
.lista-botao-dropdown-notificacao {
  width: 300px;
}
</style>
